// Field-ops API helpers — map, tech manifest, check-ins.
// Split from client.ts for file-size hygiene (hard limit 400).

import { manufacturingFetch } from "@/lib/manufacturingClient";
import type {
  ServiceCheckIn,
  ServiceCheckInMilestone,
  ServiceMapRouteSuggestion,
  ServiceTechManifest,
} from "./types";

type OrgEnvelope = { ok: true; organization_id: string };

export function listServiceMapSuggestions(opts?: {
  horizon_days?: number;
  scheduled_date?: string;
  route_date?: string;
  queue_id?: string;
  tech_id?: string;
  rig_id?: string;
}) {
  const q = new URLSearchParams();
  if (opts?.horizon_days != null) q.set("horizon_days", String(opts.horizon_days));
  if (opts?.scheduled_date) q.set("scheduled_date", opts.scheduled_date);
  if (opts?.route_date) q.set("route_date", opts.route_date);
  if (opts?.queue_id) q.set("queue_id", opts.queue_id);
  if (opts?.tech_id) q.set("tech_id", opts.tech_id);
  if (opts?.rig_id) q.set("rig_id", opts.rig_id);
  const qs = q.toString();
  const path = qs ? `/api/service/map/suggestions?${qs}` : "/api/service/map/suggestions";
  return manufacturingFetch<OrgEnvelope & ServiceMapRouteSuggestion>(path, {
    method: "GET",
  });
}

export function getServiceTechManifest(opts?: { horizon_days?: number; route_date?: string }) {
  const q = new URLSearchParams();
  if (opts?.horizon_days != null) q.set("horizon_days", String(opts.horizon_days));
  if (opts?.route_date) q.set("route_date", opts.route_date);
  const qs = q.toString();
  const path = qs ? `/api/service/tech/manifest?${qs}` : "/api/service/tech/manifest";
  return manufacturingFetch<OrgEnvelope & { manifest: ServiceTechManifest }>(path, {
    method: "GET",
  });
}

export function listServiceCheckIns(eventId: string) {
  const q = new URLSearchParams({ event_id: eventId });
  return manufacturingFetch<OrgEnvelope & { check_ins: ServiceCheckIn[] }>(
    `/api/service/check-ins?${q.toString()}`,
    { method: "GET" }
  );
}

export function recordServiceCheckIn(payload: {
  event_id: string;
  milestone: ServiceCheckInMilestone;
  notes?: string;
  evidence_url?: string | null;
}) {
  return manufacturingFetch<OrgEnvelope & { check_in: ServiceCheckIn }>("/api/service/check-ins/record", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export function stampServiceTechCheckIn(payload: {
  event_id: string;
  milestone: string;
  notes?: string;
  evidence_url?: string | null;
}) {
  return manufacturingFetch<OrgEnvelope & { check_in: ServiceCheckIn }>("/api/service/check-ins/record", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
